// extracted by mini-css-extract-plugin
module.exports = {"keypad":"Keypad_keypad__F1JHv","btn":"Keypad_btn__11Ydv"};